export default __webpack_public_path__ + "static/media/testimonial-3.cbf47205.webp";